var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnNavBack = function SvgBtnNavBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.758 3.214a.726.726 0 0 1 1.029 0 .731.731 0 0 1 0 1.032l-8.758 8.786L4 12l8.758-8.786Z",
    fill: "#242526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.787 19.754a.731.731 0 0 1 0 1.032.726.726 0 0 1-1.029 0L4 12l1.029-1.032 8.758 8.786Z",
    fill: "#242526"
  })));
};
export default SvgBtnNavBack;